<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Información financiera consolidada</h4>
        </div>
        <form v-if="!form.er.locked" @submit.prevent="validateForm('formER')" data-vv-scope="formER">
            <card  id="toERElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Información adicional</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Endeudamiento *</label>
                        <vue-numeric  :max=999999999 disabled tabindex="0" currency="$" autocomplete="off" name="endeudamiento" v-validate="modelValidations.indebtness" :error="getError('endeudamiento')" separator="." class="form-control" v-model="form.indebtness"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Tipo de cartera *</label>
                        <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox disabled v-model="form.debt.cial" :checked="false">CIAL</p-checkbox>
                            <p-checkbox disabled v-model="form.debt.mc" class="ml-2" :checked="false">MC</p-checkbox>
                        </div>
                    </div>
                    <h6 class="orange">Estado de resultados (Gastos operativos)</h6>
                    <div class="form-group">
                        <label>Número de empleados *</label>
                        <fg-input   disabled
                                    type="number"
                                    tabindex="1"
                                    name="empleados"
                                    placeholder="empleados"
                                    autocomplete="off"
                                    v-validate="modelValidations.employees"
                                    data-vv-id = "formER.empleados"
                                    :error="getError('formER.empleados')"
                                    v-model="form.er.employees">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Ingresos por ventas al contado *</label>
                        <vue-numeric  :max=999999999 disabled tabindex="2" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.indebtness" data-vv-id = "formER.ingresos" :error="getError('formER.ingresos')" separator="." class="form-control" v-model="form.er.account_sales"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Recuperación de ventas a crédito *</label>
                        <vue-numeric  :max=999999999 disabled tabindex="3" currency="$" autocomplete="off" name="recuperación" v-validate="modelValidations.indebtness" data-vv-id = "formER.recuperación" :error="getError('formER.recuperación')" separator="." class="form-control" v-model="form.er.credit_sales"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Costo de ventas *</label>
                        <vue-numeric  :max=999999999 disabled tabindex="4" currency="$" autocomplete="off" name="costo" v-validate="modelValidations.indebtness" data-vv-id = "formER.costo" :error="getError('formER.costo')" separator="." class="form-control" v-model="form.er.sales_costs"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Utilidad bruta *</label>
                        <vue-numeric  :max=999999999 disabled currency="$" autocomplete="off" name="utilidad" v-validate="modelValidations.indebtness" data-vv-id = "formER.utilidad" :error="getError('formER.utilidad')" separator="." class="form-control" v-model="gross_profit_computed"></vue-numeric>
                    </div>
                    <hr>
                    <h6 class="white">GASTOS OPERATIVOS</h6>
                    <div class="form-group">
                        <label>Salarios</label>
                        <vue-numeric  :max=999999999 disabled tabindex="5" currency="$" autocomplete="off" name="salarios" v-validate="modelValidations.sales" data-vv-id = "formER.salarios" :error="getError('formER.salarios')" separator="." class="form-control" v-model="form.er.operative_expenses.salaries.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Alquiler</label>
                        <vue-numeric  :max=999999999 disabled tabindex="6" currency="$" autocomplete="off" name="alquiler" v-validate="modelValidations.sales" data-vv-id = "formER.alquiler" :error="getError('formER.alquiler')" separator="." class="form-control" v-model="form.er.operative_expenses.rental.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Servicios públicos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="7" currency="$" autocomplete="off" name="servicios" v-validate="modelValidations.sales" data-vv-id = "formER.servicios" :error="getError('formER.servicios')" separator="." class="form-control" v-model="form.er.operative_expenses.public_services.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Impuestos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="8" currency="$" autocomplete="off" name="impuestos" v-validate="modelValidations.sales" data-vv-id = "formER.impuestos" :error="getError('formER.impuestos')" separator="." class="form-control" v-model="form.er.operative_expenses.taxes.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Transporte</label>
                        <vue-numeric  :max=999999999 disabled tabindex="9" currency="$" autocomplete="off" name="transporte" v-validate="modelValidations.sales" data-vv-id = "formER.transporte" :error="getError('formER.transporte')" separator="." class="form-control" v-model="form.er.operative_expenses.transport.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Gastos financieros</label>
                        <vue-numeric  :max=999999999 disabled tabindex="10" currency="$" autocomplete="off" name="gastos" v-validate="modelValidations.sales" data-vv-id = "formER.gastos" :error="getError('formER.gastos')" separator="." class="form-control" v-model="form.er.operative_expenses.financial_expenses.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otros gastos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="11" currency="$" autocomplete="off" name="gastos" v-validate="modelValidations.sales" data-vv-id = "formER.otros" :error="getError('formER.otros')" separator="." class="form-control" v-model="form.er.operative_expenses.others.value"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Imprevistos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="12" currency="$" autocomplete="off" name="gastos" v-validate="modelValidations.sales" data-vv-id = "formER.imprevistos" :error="getError('formER.imprevistos')" separator="." class="form-control" v-model="form.er.operative_expenses.incidentals.value"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL GASTOS OPERATIVOS: {{setFormat(operative_expenses_computed)}}</span>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>UTILIDAD NETA: {{setFormat(net_profit_computed)}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button @click="validateForm('formER')" class="btn btn-warning">Siguiente</p-button>
                        <!--<p-button @click="toBusinessReferences()" type="default" class="pull-left mb-3">Atrás</p-button>-->
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.if.locked" @submit.prevent="validateForm('formIF')" data-vv-scope="formIF">
            <card  id="toIFElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Ingresos familiares</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Ingresos del negocio</label>
                        <vue-numeric  :max=999999999 disabled tabindex="13" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.sales" data-vv-id = "formIF.ingresos" :error="getError('formIF.ingresos')" separator="." class="form-control" v-model="form.if.incomes.business_income"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salario/Pensión titular</label>
                        <vue-numeric  :max=999999999 disabled tabindex="14" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.titular_salary"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salario/Pensión cónyugue</label>
                        <vue-numeric  :max=999999999 disabled tabindex="15" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.spouse_salary"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otros ingresos netos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="16" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.incomes.others"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>Total ingresos: {{setFormat(family_income_computed)}}</span>
                    </div>
                    <h6 class="orange">Egresos de la unidad familiar</h6>
                    <div class="form-group">
                        <label>Alquiler</label>
                        <vue-numeric  :max=999999999 disabled tabindex="17" currency="$" autocomplete="off" name="alquiler" v-validate="modelValidations.sales" data-vv-id = "formIF.alquiler" :error="getError('formIF.alquiler')" separator="." class="form-control" v-model="form.if.expenses.rental"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Alimentación</label>
                        <vue-numeric  :max=999999999 disabled tabindex="18" currency="$" autocomplete="off" name="alimentación" v-validate="modelValidations.sales" data-vv-id = "formIF.alimentación" :error="getError('formIF.alimentación')" separator="." class="form-control" v-model="form.if.expenses.feeding"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Servicios públicos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="19" currency="$" autocomplete="off" name="servicios" v-validate="modelValidations.sales" data-vv-id = "formIF.servicios" :error="getError('formIF.servicios')" separator="." class="form-control" v-model="form.if.expenses.public_services"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Educación</label>
                        <vue-numeric  :max=999999999 disabled tabindex="20" currency="$" autocomplete="off" name="educación" v-validate="modelValidations.sales" data-vv-id = "formIF.educación" :error="getError('formIF.educación')" separator="." class="form-control" v-model="form.if.expenses.education"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salud</label>
                        <vue-numeric  :max=999999999 disabled tabindex="21" currency="$" autocomplete="off" name="salud" v-validate="modelValidations.sales" data-vv-id = "formIF.salud" :error="getError('formIF.salud')" separator="." class="form-control" v-model="form.if.expenses.health"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuotas créditos recibidos por UF</label>
                        <vue-numeric  :max=999999999 disabled tabindex="22" currency="$" autocomplete="off" name="cuotas" v-validate="modelValidations.sales" data-vv-id = "formIF.cuotas" :error="getError('formIF.cuotas')" separator="." class="form-control" v-model="form.if.expenses.credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Transporte</label>
                        <vue-numeric  :max=999999999 disabled tabindex="23" currency="$" autocomplete="off" name="transporte" v-validate="modelValidations.sales" data-vv-id = "formIF.transporte" :error="getError('formIF.transporte')" separator="." class="form-control" v-model="form.if.expenses.transport"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otros</label>
                        <vue-numeric  :max=999999999 disabled tabindex="24" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.expenses.others"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Imprevistos * 10%</label>
                        <vue-numeric  :max=999999999 disabled tabindex="25" currency="$" autocomplete="off" name="imprevistos" v-validate="modelValidations.sales" data-vv-id = "formIF.imprevistos" :error="getError('formIF.imprevistos')" separator="." class="form-control" v-model="family_expenses_incidentals_computed"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL EGRESOS UF: {{setFormat(family_expenses_computed)}}</span>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>EXCEDENTE: {{setFormat(family_surplus_computed)}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formIF')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toER()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.b.locked" @submit.prevent="validateForm('formB')" data-vv-scope="formB">
            <card  id="toBElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Balance</h6>
                </div>
                <div class="card-body">
                    <h6 class="white">ACTIVO</h6>
                    <div class="form-group">
                        <label>Caja</label>
                        <vue-numeric  :max=999999999 disabled tabindex="26" currency="$" autocomplete="off" name="caja" v-validate="modelValidations.sales" :error="getError('formB.caja')" separator="." class="form-control" v-model="form.b.assets.cash"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Bancos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="27" currency="$" autocomplete="off" name="bancos" v-validate="modelValidations.sales" :error="getError('formB.bancos')" separator="." class="form-control" v-model="form.b.assets.banks"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuentas ahorros/CDTs BMM</label>
                        <vue-numeric  :max=999999999 disabled tabindex="28" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.saving_accounts"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuentas a cobrar a clientes</label>
                        <vue-numeric  :max=999999999 disabled tabindex="29" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.accounts_receivable"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Inventarios</label>
                        <vue-numeric  :max=999999999 disabled tabindex="30" currency="$" autocomplete="off" name="inventarios" v-validate="modelValidations.sales" :error="getError('formB.inventarios')" separator="." class="form-control" v-model="form.b.assets.inventory"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras cuentas de ahorro corriente</label>
                        <vue-numeric  :max=999999999 disabled tabindex="31" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.others_accounts"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL ACTIVO CORRIENTE: {{setFormat(total_current_assets_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Inmuebles</label>
                        <vue-numeric  :max=999999999 disabled tabindex="32" currency="$" autocomplete="off" name="inmuebles" v-validate="modelValidations.sales" :error="getError('formB.inmuebles')" separator="." class="form-control" v-model="form.b.assets.estate"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Muebles, maquinaria y equipo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="33" currency="$" autocomplete="off" name="muebles" v-validate="modelValidations.sales" :error="getError('formB.muebles')" separator="." class="form-control" v-model="form.b.assets.equipment"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Vehículo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="34" currency="$" autocomplete="off" name="vehículo" v-validate="modelValidations.sales" :error="getError('formB.vehículo')" separator="." class="form-control" v-model="form.b.assets.vehicle"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL ACTIVO FIJO: {{setFormat(total_fixed_assets_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Otros activos</label>
                        <vue-numeric  :max=999999999 disabled tabindex="35" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" :error="getError('formB.otros')" separator="." class="form-control" v-model="form.b.assets.others_assets"></vue-numeric>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>TOTAL ACTIVO: {{setFormat(total_assets_computed)}}</span>
                    </div>
                    <h6 class="white">PASIVO</h6>
                    <div class="form-group">
                        <label>Cuentas por pagar a proveedores</label>
                        <vue-numeric  :max=999999999 disabled tabindex="36" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.passives.accounts_payable_suppliers"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos bancarios/IMF para capital de trabajo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="37" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.banks_credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos BMM para capital de trabajo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="38" currency="$" autocomplete="off" name="créditos_BMM" v-validate="modelValidations.sales" :error="getError('formB.créditos_BMM')" separator="." class="form-control" v-model="form.b.passives.BMM_credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras obligaciones para capital de trabajo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="39" currency="$" autocomplete="off" name="obligaciones" v-validate="modelValidations.sales" :error="getError('formB.obligaciones')" separator="." class="form-control" v-model="form.b.passives.others_obligations"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO CORRIENTE: {{setFormat(total_current_passives_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Créditos bancarios para activo fijo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="40" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.banks_credits_fixed_assets"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos BMM/IMF para activo fijo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="41" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.BMM_credits_fixed_assets"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras obligaciones para activo fijo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="42" currency="$" autocomplete="off" name="obligaciones" v-validate="modelValidations.sales" :error="getError('formB.obligaciones')" separator="." class="form-control" v-model="form.b.passives.others_fixed_assets"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO NO CORRIENTE: {{setFormat(total_not_current_passives_computed)}}</span>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO DEL NEGOCIO: {{setFormat(total_business_passives_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Patrimonio</label>
                        <vue-numeric  :max=999999999 disabled tabindex="43" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.sales" :error="getError('formB.patrimonio')" separator="." class="form-control" v-model="patrimony_computed"></vue-numeric>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>TOTAL PASIVO y PATRIMONIO: {{setFormat(total_passive_patrimony_computed)}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button @click="validateForm('formB')" type="warning">Siguiente</p-button>
                        <p-button v-if="validateStudy()" @click="toIF()" type="default" class="pull-left mb-3">Atrás</p-button>
                        <p-button v-else @click="toER()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--Financial obligations-->
        <!--add financial obligation -->
        <modal :show.sync="addObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar obligación</h6>
                <div class="form-group">
                    <label>Acreedor *</label>
                    <fg-input   type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('acreedor')"
                                v-model="obligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="obligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="obligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label># de cuots pendientes *</label>
                    <fg-input   type="number"
                                name="cuotas"
                                placeholder="cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('cuotas')"
                                v-model="obligationNumberPayments">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addObligationToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!-- /add financial obligation -->
        <!-- edit financial obligation -->
        <modal :show.sync="editObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación</h6>
                <div class="form-group">
                    <label>Acreedor *</label>
                    <fg-input   type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('acreedor')"
                                v-model="obligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="obligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="obligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label># de cuots pendientes *</label>
                    <fg-input   type="number"
                                name="cuotas"
                                placeholder="cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('cuotas')"
                                v-model="obligationNumberPayments">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editFamiliarObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación familiar</h6>
                <div class="form-group">
                    <label>Crédito recibido *</label>
                    <fg-input   disabled
                                type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('acreedor')"
                                v-model="familiarObligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="familiarObligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Saldo *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="saldo" v-validate="modelValidations.obligation" :error="getError('saldo')" separator="." class="form-control" v-model="familiarObligationResidue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="familiarObligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('plazo')"
                                v-model="familiarObligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditFamiliarObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editFamiliarObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- /edit financial obligation -->
        <form v-if="!form.of.locked" @submit.prevent="validateForm('formOF')" data-vv-scope="formOF">
            <card  id="toOFElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Obligaciones financieras del negocio</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.of.business.obligations.length" :data="form.of.business.obligations"  ref="obligationsTable"  highlight-current-row @current-change="handleCurrentObligationChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Acreedor: {{ props.row.obligationCreditor }}</p>
                                <p>Monto: {{ setFormat(props.row.obligationAmount) }}</p>
                                <p>Valor cuota: {{ setFormat(props.row.obligationPaymentValue) }}</p>
                                <p># de cuots pendientes: {{ props.row.obligationNumberPayments }}</p>
                                <p>Plazo: {{ props.row.obligationTerm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Acreedor" property="obligationCreditor"></el-table-column>
                        <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationAmount)}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Cuota">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationPaymentValue)}}</span>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <!--<div>
                        <p-button
                            @click="addObligationMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar obligación
                        </p-button>
                        <br>
                        <p-button v-if="currentObligationRow"
                            @click="editObligationMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar obligación
                        </p-button>
                        <br>
                        <p-button v-if="currentObligationRow"
                            @click="removeObligationMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar obligación
                        </p-button>
                    </div>-->
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formOF')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toB()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.of.familiar.locked" @submit.prevent="validateForm('formOFU')" data-vv-scope="formOFU">
            <card id="toOFUElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Obligaciones financieras de la unidad familiar</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.of.familiar.familiarObligations.length" :data="form.of.familiar.familiarObligations"  ref="familiarObligationsTable"  highlight-current-row @current-change="handleCurrentFamiliarObligationChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Créditos recibidos: {{ props.row.obligationCreditor }}</p>
                                <p>Monto: {{ setFormat(props.row.obligationAmount) }}</p>
                                <p>Saldo: {{ setFormat(props.row.obligationResidue) }}</p>
                                <p>Valor cuota: {{ setFormat(props.row.obligationPaymentValue) }}</p>
                                <p>Plazo: {{ props.row.obligationTerm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Crédito" property="obligationCreditor"></el-table-column>
                        <!-- <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationAmount)}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Saldo">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationResidue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--<div>
                        <p-button v-if="currentFamiliarObligationRow"
                            @click="editFamiliarObligationMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar obligación
                        </p-button>
                    </div>-->
                    <br>
                    <h6 class="orange">Patrimonio U.F.</h6>
                    <div class="form-group">
                        <label>Valor estimado Casa/Finca</label>
                        <vue-numeric  :max=999999999 disabled tabindex="44" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.indebtness" :error="getError('patrimonio')" separator="." class="form-control" v-model="form.of.familiar.patrimonyHouse"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Valor estimado Vehículo</label>
                        <vue-numeric  :max=999999999 disabled tabindex="45" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.indebtness" :error="getError('patrimonio')" separator="." class="form-control" v-model="form.of.familiar.patrimonyVehicle"></vue-numeric>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formOFU')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toOF()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!-- /Financial obligations-->
        <!-- Equipment  -->
        <!--add Equipment-->
        <modal :show.sync="addEquipment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar</h6>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   type="text"
                                name="descripción"
                                placeholder="descripción"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('descripción')"
                                v-model="equipmentDescription">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="equipmentValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddEquipment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addEquipmentToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <!--add Equipment-->
        <modal :show.sync="editEquipment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar</h6>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   type="text"
                                name="descipción"
                                placeholder="descipción"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('descipción')"
                                v-model="equipmentDescription">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="equipmentValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditEquipment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editEquipmentToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <form v-if="!form.i.equipment.locked" @submit.prevent="validateForm('formIF')" data-vv-scope="formIF">
            <card  id="toIElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Inmuebles/Muebles, maquinarias, equipos y vehículos del negocio</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.i.equipment.equipment.length" :data="form.i.equipment.equipment"  ref="equipmentsTable"  highlight-current-row @current-change="handleCurrentEquipmentChange">
                        <el-table-column label="Descripción" property="equipmentDescription"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.equipmentValue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--<div>
                        <p-button
                            @click="addEquipmentMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar
                        </p-button>
                        <br>
                        <p-button v-if="currentEquipmentRow"
                            @click="editEquipmentMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar
                        </p-button>
                        <br>
                        <p-button v-if="currentEquipmentRow"
                            @click="removeEquipmentMethod()"
                            type="default"
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar
                        </p-button>
                    </div>-->
                </div>
                <div class="card-footer">
                    <div v-if="total_equipment_computed != 0" class="alert alert-warning mt-2">
                        <span>TOTAL: {{setFormat(total_equipment_computed)}}</span>
                    </div>
                    <div class="text-right">
                            <p-button @click="validateForm('formI')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toOFU()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--./ Equipment-->
        <!-- Payment capacity-->
        <!--help-->
        <modal :show.sync="showHelp" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Información</h6>
            <div class="alert alert-warning mt-2">
                <span>Información de ayuda: {{helpText}}</span>
            </div>
            <template slot="footer">
                <p-button type="default" link @click="cancelHelp()">Cancelar</p-button>
            </template>
        </modal>
        <!--./ help-->
        <form v-if="!form.cp.locked" @submit.prevent="validateForm('formCP')" data-vv-scope="formCP">
            <card-orange  id="toCPElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Análisis de la capacidad de pago</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="payment_capacity_computed.length" :data="payment_capacity_computed" @row-dblclick="showHelpMethod" ref="paymentCapacityTable" :row-class-name="tableRowClassName2">
                        <el-table-column label="Variable" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.value)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formCP')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toI()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card-orange>
        </form>
        <!--./ Payment capacity-->
        <!--Financial indicators-->
        <form v-if="!form.i.locked" @submit.prevent="validateForm('formIFI')" data-vv-scope="formIFI">
            <card  id="toIFIElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Indicadores financieros</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.i.financialIndicators.length" :data="form.i.financialIndicators"  @row-dblclick="showHelpMethod" ref="financialIndicatorsTable" :row-class-name="tableRowClassName">
                        <el-table-column label="Indicador" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setSuffix(scope.row)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formIFI')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toCP()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--./Financial indicators-->
        <fab
        :position="position"
        :bg-color="bgColor"
        :actions="fabActions"
        main-icon='search'
        icon-size="small"
        @toER="toER"
        @toIF="toIF"
        @toB="toB"
        @toOF="toOF"
        @toOFU="toOFU"
        @toI="toI"
        @toCP="toCP"
        @toIFI="toIFI"
        ></fab>
    </div>
</template>
<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import fab from 'vue-fab'
import VueScrollTo from 'vue-scrollto'
import VueNumeric from 'vue-numeric'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import { Modal } from 'src/components/UIComponents'
import {Table, TableColumn} from 'element-ui'
import FinancialIndicators from 'src/util/FinancialIndicators/FinancialIndicators'
import PaymentCapacity from 'src/util/PaymentCapacity/PaymentCapacity'
import PaymentCapacityConsumer from 'src/util/PaymentCapacity/PaymentCapacityConsumer'
import expr from 'expression-eval'
import moment from 'moment'
import { isEmpty } from 'lodash';
Vue.use(Table)
Vue.use(TableColumn)
// You can also pass in the default options
Vue.use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
})
export default {
    components: {
        fab,
        VueNumeric,
        Modal
    },
    data(){
        return {
            modifiedFinancialIndicators: true,
            showHelp: false,
            helpText: null,
            financialIndicators: [],
            currentObligationRow: null,
            currentEquipmentRow: null,
            currentFamiliarObligationRow: null,
            obligations: [],
            familiarObligations: [{
                obligationCreditor: 'T. de crédito',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            },
            {
                obligationCreditor: 'Cred. consumo',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            },
            {
                obligationCreditor: 'Cred. vivienda',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            }],
            addFamiliarObligation: false,
            editFamiliarObligation: false,
            addObligation: false,
            editObligation: false,
            addEquipment: false,
            editEquipment: false,
            equipmentDescription: '',
            equipmentValue: '',
            familiarObligationCreditor: '',
            familiarObligationAmount: '',
            familiarObligationPaymentValue: '',
            familiarObligationResidue: '',
            familiarObligationTerm: '',
            obligationCreditor: '',
            obligationAmount: '',
            obligationPaymentValue: '',
            obligationNumberPayments: '',
            obligationTerm: '',
            bgColor: '#F09500',
            position: 'bottom-right',
            fabActions: [
                {
                    name: 'toER',
                    icon: 'ER'
                },
            ],
            fabActions2: [
                {
                    name: 'toER',
                    icon: 'ER'
                },
                {
                    name: 'toIF',
                    icon: 'IF'
                },
                {
                    name: 'toB',
                    icon: 'B'
                },
                {
                    name: 'toOF',
                    icon: 'OF'
                },
                {
                    name: 'toOFU',
                    icon: 'OFU'
                },
                {
                    name: 'toI',
                    icon: 'I'
                },
                {
                    name: 'toCP',
                    icon: 'CP'
                },
                {
                    name: 'toIFI',
                    icon: 'IFI'
                },

            ],
            form: {
                indebtness: '',
                debt: {
                    cial: false,
                    mc: false
                },
                er: {
                    locked: false,
                    employees: 0,
                    account_sales: '',
                    credit_sales: '',
                    sales_costs: '',
                    gross_profit: '',
                    net_profit: '',
                    operative_expenses: { //gastos operativos
                        salaries: {
                            value: '',
                            locked: false
                        }, //salarios
                        rental: {
                            value: '',
                            locked: false
                        },  //alquiler
                        public_services: {
                            value: '',
                            locked: false
                        },  //servicios públicos
                        taxes: {
                            value: '',
                            locked: false
                        },  //impuestos
                        transport: {
                            value: '',
                            locked: false
                        },  //transporte
                        financial_expenses: {
                            value: '',
                            locked: false
                        },  //gastos financieros
                        others: {
                            value: '',
                            locked: false
                        },  //otros
                        incidentals: {
                            value: '',
                            locked: false
                        },  //imprevistos
                        total: '' //total
                    }

                },
                if: {
                    locked: true,
                    surplus: '',
                    incomes: {
                        business_income: '',
                        titular_salary: '',
                        spouse_salary: '',
                        others: '',
                        total: ''
                    },
                    expenses: {
                        rental: '',
                        feeding: '',
                        public_services: '',
                        education: '',
                        health: '',
                        credits: '',
                        transport: '',
                        others: '',
                        incidentals: '',
                        total: ''
                    }


                },
                b: {
                    locked: true,
                    assets: {
                        cash: '',
                        banks: '',
                        saving_accounts: '',
                        accounts_receivable: '',
                        inventory: '',
                        others_accounts: '',
                        total_current_assets: '',
                        estate: '',
                        equipment: '',
                        vehicle: '',
                        total_fixed_assets: '',
                        others_assets: '',
                        total_assets: ''
                    },
                    passives: {
                        accounts_payable_suppliers: '',
                        banks_credits: '',
                        BMM_credits: '',
                        others_obligations: '',
                        total_current_passives: '',
                        banks_credits_fixed_assets: '',
                        BMM_credits_fixed_assets: '',
                        others_fixed_assets: '',
                        total_not_current_passives: '',
                        total_business_passives: '',
                        patrimony: '',
                        total_passive_patrimony: ''
                    }
                },
            of: {
                locked: true,
                business: {
                    obligations:[],
                },
                familiar: {
                    locked: true,
                    familiarObligations: [{
                        obligationCreditor: 'Tarjeta de crédito',
                        obligationAmount: '',
                        obligationResidue: '',
                        obligationPaymentValue: '',
                        obligationTerm: 0,
                    },
                    {
                        obligationCreditor: 'Crédito consumo',
                        obligationAmount: '',
                        obligationResidue: '',
                        obligationPaymentValue: '',
                        obligationTerm: 0,
                    },
                    {
                        obligationCreditor: 'Crédito vivienda',
                        obligationAmount: '',
                        obligationResidue: '',
                        obligationPaymentValue: '',
                        obligationTerm: 0,
                    }],
                    patrimonyHouse: 0,
                    patrimonyVechicle: 0
                }


            },
            i: {
                equipment: {
                    locked: true,
                    equipment: [],
                    total: 0
                },
                locked: true,
                financialIndicators: []
            },
            cp: {
                locked: true,
                paymentCapacity: []
            }
            },

            modelValidations: {
                indebtness: {
                    required: true
                },
                employees: {
                    required: true,
                    numeric: true
                },
                sales: {
                    required: true
                },
                obligation: {
                    required: true
                }
            },
        }
    },
    computed: {
        total_equipment_computed: {
            get () {
                var sum = 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    sum = sum + parseFloat(this.form.i.equipment.equipment[i].equipmentValue || 0);
                }
                this.form.i.equipment.total = sum;
                return sum;
            },
            set () {

            }
        },
        total_passive_patrimony_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_passive_patrimony = parseFloat(this.patrimony_computed || 0) + parseFloat(this.total_business_passives_computed || 0);
                total = this.form.b.passives.total_passive_patrimony;
                return total
            },
            set () {

            }
        },
        patrimony_computed: {
            get () {
                var total = 0;
                this.form.b.passives.patrimony = parseFloat(this.total_assets_computed || 0) - parseFloat(this.total_business_passives_computed || 0);
                total = this.form.b.passives.patrimony;
                return total
            },
            set () {

            }
        },
        total_business_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_business_passives = parseFloat(this.total_not_current_passives_computed || 0) + parseFloat(this.total_current_passives_computed || 0);
                total = this.form.b.passives.total_business_passives;
                return total
            },
            set () {

            }
        },
        total_not_current_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_not_current_passives = parseFloat(this.form.b.passives.banks_credits_fixed_assets || 0) + parseFloat(this.form.b.passives.BMM_credits_fixed_assets || 0) + parseFloat(this.form.b.passives.others_fixed_assets || 0);
                total = this.form.b.passives.total_not_current_passives;
                return total
            },
            set () {

            }
        },
        total_current_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_current_passives = parseFloat(this.form.b.passives.accounts_payable_suppliers || 0) + parseFloat(this.form.b.passives.banks_credits || 0) + parseFloat(this.form.b.passives.BMM_credits || 0) + parseFloat(this.form.b.passives.others_obligations || 0);
                total = this.form.b.passives.total_current_passives;
                return total
            },
            set () {

            }
        },
        total_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_assets = parseFloat(this.form.b.assets.others_assets || 0) + parseFloat(this.total_fixed_assets_computed || 0) + parseFloat(this.total_current_assets_computed || 0);
                total = this.form.b.assets.total_assets;
                return total
            },
            set () {

            }
        },
        total_fixed_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_fixed_assets = parseFloat(this.form.b.assets.estate || 0) + parseFloat(this.form.b.assets.equipment || 0) + parseFloat(this.form.b.assets.vehicle || 0);
                total = this.form.b.assets.total_fixed_assets;
                return total
            },
            set () {

            }
        },
        total_current_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_current_assets = parseFloat(this.form.b.assets.cash || 0) + parseFloat(this.form.b.assets.banks || 0) + parseFloat(this.form.b.assets.saving_accounts || 0) + parseFloat(this.form.b.assets.accounts_receivable || 0) + parseFloat(this.form.b.assets.inventory || 0) + parseFloat(this.form.b.assets.others_accounts || 0);
                total = this.form.b.assets.total_current_assets;
                return total
            },
            set () {

            }
        },
        gross_profit_computed: {
            get () {
                var total = 0;
                this.form.er.gross_profit = parseFloat(this.form.er.account_sales || 0) + parseFloat(this.form.er.credit_sales || 0) - parseFloat(this.form.er.sales_costs || 0);
                total = this.form.er.gross_profit;
                return total;
            },
            set () {

            }
        },
        operative_expenses_computed: {
            get () {
                var total = 0;
                this.form.er.operative_expenses.total = parseFloat(this.form.er.operative_expenses.salaries.value || 0) + parseFloat(this.form.er.operative_expenses.rental.value || 0) + parseFloat(this.form.er.operative_expenses.public_services.value || 0) + parseFloat(this.form.er.operative_expenses.taxes.value || 0) + parseFloat(this.form.er.operative_expenses.transport.value || 0) + parseFloat(this.form.er.operative_expenses.financial_expenses.value || 0) + parseFloat(this.form.er.operative_expenses.others.value || 0) + parseFloat(this.form.er.operative_expenses.incidentals.value || 0);
                var total = this.form.er.operative_expenses.total;
                return total;
            },
            set () {

            }
        },
        net_profit_computed: {
            get () {
                var total = 0;
                this.form.er.net_profit = parseFloat(this.gross_profit_computed || 0) - parseFloat(this.operative_expenses_computed || 0);
                this.form.if.incomes.business_income = this.form.er.net_profit;
                total = this.form.er.net_profit;
                return total;
            },
            set () {

            }
        },
        family_income_computed: {
            get () {
                var total = 0;
                this.form.if.incomes.total = parseFloat(this.form.if.incomes.business_income  || 0) + parseFloat(this.form.if.incomes.titular_salary || 0) + parseFloat(this.form.if.incomes.spouse_salary || 0) + parseFloat(this.form.if.incomes.others || 0);
                total = this.form.if.incomes.total;
                return total;
            },
            set () {

            }
        },
        family_expenses_incidentals_computed: {
            get () {
                var total = 0;
                this.form.if.expenses.incidentals = parseFloat(this.family_income_computed  || 0) * 10 / 100;
                total = this.form.if.expenses.incidentals;
                return total;
            },
            set () {

            }
        },
        family_expenses_computed: {
            get () {
                var total = 0;
                this.form.if.expenses.total = parseFloat(this.form.if.expenses.rental || 0) + parseFloat(this.form.if.expenses.feeding || 0) + parseFloat(this.form.if.expenses.public_services || 0) + parseFloat(this.form.if.expenses.education || 0) + parseFloat(this.form.if.expenses.health || 0) + parseFloat(this.form.if.expenses.credits || 0) + parseFloat(this.form.if.expenses.transport || 0) + parseFloat(this.form.if.expenses.others || 0) + parseFloat(this.form.if.expenses.incidentals || 0);
                total = this.form.if.expenses.total;
                return total;
            },
            set () {

            }
        },
        family_surplus_computed: {
            get () {
                var total = 0;
                this.form.if.surplus = parseFloat(this.family_income_computed || 0) - parseFloat(this.family_expenses_computed || 0);
                total = this.form.if.surplus;
                return total;
            },
            set () {

            }
        },
        payment_capacity_computed: {
            get () {
                for (let i=0;i<this.form.cp.paymentCapacity.length;i++) {
                    if (this.$store.state.actualAssesment != null) {
                        var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                        if (product.name.toLowerCase() == 'consumo') {
                            if (this.form.cp.paymentCapacity[i].id == 1) {
                                this.form.cp.paymentCapacity[i].value = this.family_income_computed * 30 / 100;
                            }
                            else if(this.form.cp.paymentCapacity[i].id == 2) {
                                this.form.cp.paymentCapacity[i].value = this.family_surplus_computed * 50 / 100;
                            }
                            else if(this.form.cp.paymentCapacity[i].id == 3) {
                                this.form.cp.paymentCapacity[i].value = this.family_income_computed * 40 / 100;;
                            }
                            else if(this.form.cp.paymentCapacity[i].id == 4){
                                var a = this.family_income_computed * 30 / 100;
                                var b = this.family_surplus_computed * 50 / 100;
                                var c = this.family_income_computed * 40 / 100;
                                var arrayComputed = [a, b, c];
                                var minimum = Math.min(...arrayComputed);
                                this.form.cp.paymentCapacity[i].value = minimum;
                            }
                        }
                        else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                            var evalResult = 0;
                            evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                            this.form.cp.paymentCapacity[i].value = evalResult;
                        }
                    }
                }
                return this.form.cp.paymentCapacity;
            },
            set () {

            }
        }
    },
    watch: {
            'form.debt.cial': function (newVal, oldVal) {
                if (newVal) {
                    this.form.debt.mc = false;
                }
            },
            'form.debt.mc': function (newVal, oldVal) {
                if (newVal) {
                    this.form.debt.cial = false;
                }
            },
        },
    methods:{
        validateStudy () {
            if (this.$store.state.actualAssesment != null) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                    return true
                }
                else {
                    return false
                }
            }
            else {
                return false
            }

        },
        cancelHelp () {
            this.showHelp = false;
            this.helpText = null;
        },
        showHelpMethod (row) {
            this.helpText = row.info;
            this.showHelp = true;
        },
        setPaymentEval (id) {
            switch (id) {
            case 1:
                return this.form.er.net_profit;
                break;
            case 2:
                if (this.form.if.incomes.business_income != this.form.if.incomes.total) { return (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { return this.form.if.expenses.total }
                break;
            case 3:
                var operation = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { operation = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { operation = this.form.if.expenses.total }; return this.form.er.net_profit - operation;
                break;
            case 4:
                var operation = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { operation = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { operation = this.form.if.expenses.total }; return (this.form.er.net_profit - operation)*0.6;
                break;
            default:
                console.log('default');
            }
        },
        setEval (str) {
            const ast = expr.parse(str);
            return expr.eval(ast, this.$data)
        },
        setSuffix (row) {
            if (isNaN(row.value) || row.value == 'Infinity') {
                return 'Revisa los valores'
            }
            else {
                if (row.unit == '$') {
                    return this.setFormat(row.value);
                }
                else {
                    return [row.value,' ',row.unit].join('');
                }
            }

        },
        tableRowClassName({row, rowIndex}) {
            if (row.formula != null && this.modifiedFinancialIndicators) {
                let result = this.setEval(row.formula);
                this.form.i.financialIndicators[rowIndex].value = Number((result).toFixed(2));
                let finalFormula = [result,' ',row.alert].join('')
                if(this.setEval(finalFormula) == true || isNaN(result) || result == 'Infinity') {
                    return 'warning-row';
                }
                else {
                    return '';
                }
                return ''
            }
        },
        tableRowClassName2({row, rowIndex}) {
            if (row.name == 'Capacidad de pago (60%)') {
                return 'capacity-row';
            }
            else {
                return ''
            }
        },
        showNotificationError (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-glasses-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
        },
        showNotificationSuccess (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-check-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success'
            })
        },
        handleCurrentObligationChange(currentRow, oldCurrentRow) {
                this.currentObligationRow = currentRow;
        },
        handleCurrentEquipmentChange(currentRow, oldCurrentRow) {
                this.currentEquipmentRow = currentRow;
        },
        handleCurrentFamiliarObligationChange(currentRow, oldCurrentRow) {
                this.currentFamiliarObligationRow = currentRow;
        },
        cancelAddObligation () {
            this.addObligation = false;
        },
        cancelAddEquipment () {
            this.resetEquipment();
            this.addEquipment = false;
        },
        addObligationToList () {
            if (this.obligationCreditor == '' || this.obligationAmount == '' || this.obligationPaymentValue == '' || this.obligationNumberPayments == '' || this.obligationTerm == '') {
                this.showNotificationError('Revisa y completa el formulario');
            }
            else {
                this.form.of.business.obligations.push({
                    obligationCreditor:  this.obligationCreditor,
                    obligationAmount: this.obligationAmount,
                    obligationPaymentValue: this.obligationPaymentValue,
                    obligationNumberPayments: this.obligationNumberPayments,
                    obligationTerm: this.obligationTerm,
                })
                this.resetObligation();
                this.addObligation = false;
                this.showNotificationSuccess('Obligación creada correctamente');
            }
        },
        addEquipmentToList () {
            if (this.equipmentDescription == '' || this.equipmentValue == '') {
                this.showNotificationError('Revisa y completa el formulario');
            }
            else {
                this.form.i.equipment.equipment.push({
                    equipmentDescription:  this.equipmentDescription,
                    equipmentValue: this.equipmentValue
                })
                this.resetEquipment();
                this.addEquipment = false;
                this.showNotificationSuccess('Ítem agregado correctamente');
            }
        },
        resetObligation () {
            this.obligationCreditor = '';
            this.obligationAmount = '';
            this.obligationPaymentValue = '';
            this.obligationNumberPayments = '';
            this.obligationTerm = '';
        },
        resetEquipment () {
            this.equipmentDescription = '';
            this.equipmentValue = '';
        },
        cancelEditObligation () {
            this.editObligation = false;
        },
        cancelEditEquipment () {
            this.editEquipment = false;
        },
        cancelEditFamiliarObligation () {
            this.editFamiliarObligation = false;
        },
        editObligationToList () {
            if (this.obligationCreditor == '' || this.obligationAmount == '' || this.obligationPaymentValue == '' || this.obligationNumberPayments == '' || this.obligationTerm == '') {
                this.showNotificationError('Revisa y completa el formulario');
            }
            else {
                var index = this.form.of.business.obligations.indexOf(this.currentObligationRow);
                this.form.of.business.obligations[index].obligationCreditor = this.obligationCreditor;
                this.form.of.business.obligations[index].obligationAmount = this.obligationAmount;
                this.form.of.business.obligations[index].obligationPaymentValue = this.obligationPaymentValue;
                this.form.of.business.obligations[index].obligationNumberPayments = this.obligationNumberPayments;
                this.form.of.business.obligations[index].obligationTerm = this.obligationTerm;
                this.resetObligation();
                this.$refs.obligationsTable.setCurrentRow();
                this.editObligation = false;
                this.showNotificationSuccess('Obligación editada correctamente');
            }
        },
        editEquipmentToList () {
            if (this.equipmentDescription == '' || this.equipmentValue == '') {
                this.showNotificationError('Revisa y completa el formulario');
            }
            else {
                var index = this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow);
                this.form.i.equipment.equipment[index].equipmentDescription = this.equipmentDescription;
                this.form.i.equipment.equipment[index].equipmentValue = this.equipmentValue;
                this.resetEquipment();
                this.$refs.equipmentsTable.setCurrentRow();
                this.editEquipment = false;
                this.showNotificationSuccess('Obligación editada correctamente');
            }
        },
        editFamiliarObligationToList () {
            if (this.familiarObligationCreditor == '' || this.familiarObligationAmount == '' || this.familiarObligationPaymentValue == '' || this.familiarObligationResidue == '' || this.familiarObligationTerm == 0) {
                this.showNotificationError('Revisa y completa el formulario');
            }
            else {
                if(this.familiarObligationResidue > this.familiarObligationAmount) {
                    this.showNotificationError('El saldo no puede ser mayor al monto');
                    return
                }
                var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
                this.form.of.familiar.familiarObligations[index].obligationCreditor = this.familiarObligationCreditor;
                this.form.of.familiar.familiarObligations[index].obligationAmount = this.familiarObligationAmount;
                this.form.of.familiar.familiarObligations[index].obligationPaymentValue = this.familiarObligationPaymentValue;
                this.form.of.familiar.familiarObligations[index].obligationResidue = this.familiarObligationResidue;
                this.form.of.familiar.familiarObligations[index].obligationTerm = this.familiarObligationTerm;
                this.$refs.familiarObligationsTable.setCurrentRow();
                this.editFamiliarObligation = false;
                this.showNotificationSuccess('Obligación familiar editada correctamente');
            }
        },
        addObligationMethod () {
            this.addObligation = true;
        },
        addEquipmentMethod () {
            this.addEquipment = true;
        },
        editObligationMethod () {
            var index = this.form.of.business.obligations.indexOf(this.currentObligationRow);
            this.obligationCreditor = this.form.of.business.obligations[index].obligationCreditor;
            this.obligationAmount = this.form.of.business.obligations[index].obligationAmount;
            this.obligationPaymentValue = this.form.of.business.obligations[index].obligationPaymentValue;
            this.obligationNumberPayments = this.form.of.business.obligations[index].obligationNumberPayments;
            this.obligationTerm = this.form.of.business.obligations[index].obligationTerm;
            this.editObligation = true;
        },
        editEquipmentMethod () {
            var index = this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow);
            this.equipmentDescription = this.form.i.equipment.equipment[index].equipmentDescription;
            this.equipmentValue = this.form.i.equipment.equipment[index].equipmentValue;
            this.editEquipment = true;
        },
        editFamiliarObligationMethod () {
            var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
            this.familiarObligationCreditor = this.form.of.familiar.familiarObligations[index].obligationCreditor;
            this.familiarObligationAmount = this.form.of.familiar.familiarObligations[index].obligationAmount;
            this.familiarObligationPaymentValue = this.form.of.familiar.familiarObligations[index].obligationPaymentValue;
            this.familiarObligationResidue = this.form.of.familiar.familiarObligations[index].obligationResidue;
            this.familiarObligationTerm = this.form.of.familiar.familiarObligations[index].obligationTerm;
            this.editFamiliarObligation = true;
        },
        removeObligationMethod () {
            this.obligations.splice(this.form.of.business.obligations.indexOf(this.currentObligationRow),1);
            this.currentObligationRow = null;
        },
        removeEquipmentMethod () {
            this.form.i.equipment.equipment.splice(this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow),1);
            this.currentEquipmentRow = null;
        },
        setFormat (value) {
            return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setIncomeType (value) {
            if (value == '1') {
                return 'Bonificaciones y comisiones'
            }
            else if (value == '2') {
                return 'Microempresariales'
            }
            else if (value == '3') {
                return 'Otros'
            }
        },
        toER () {
            VueScrollTo.scrollTo('#toERElement')
        },
        toIF () {
            VueScrollTo.scrollTo('#toIFElement')
        },
        toB () {
            VueScrollTo.scrollTo('#toBElement')
        },
        toOF () {
            VueScrollTo.scrollTo('#toOFElement')
        },
        toOFU () {
            VueScrollTo.scrollTo('#toOFUElement')
        },
        toI () {
            VueScrollTo.scrollTo('#toIElement')
        },
        toCP () {
            VueScrollTo.scrollTo('#toCPElement')
        },
        toIFI () {
            VueScrollTo.scrollTo('#toIFIElement')
        },
        toBusinessReferences () {
            this.$router.push('/asessments/new_asessment/customer/others/business_references');
        },
        /***
         * Función que permite visualizar los errores en cada campo del input
         */
        getError (fieldName) {
            return this.errors.first(fieldName)
        },
        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    if (scope == 'formER') {
                        var vm = this;
                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                            let promise = new Promise(function(resolve, reject) {
                                vm.form.if.locked = false;
                                resolve();
                            }).then(function(resolve){
                                if(!vm.fabActions.filter(element=> element.name == 'toIF').length > 0) {
                                    vm.fabActions.push({
                                        name: 'toIF',
                                        icon: 'IF'
                                    })
                                }
                                vm.toIF();
                            });
                        }
                        else {
                            let promise = new Promise(function(resolve, reject) {
                                vm.form.if.incomes.business_income= 0;
                                vm.form.if.incomes.titular_salary= 0;
                                vm.form.if.incomes.spouse_salary= 0;
                                vm.form.if.incomes.others= 0;
                                vm.form.if.incomes.total= 0;
                                vm.form.if.expenses.rental= 0;
                                vm.form.if.expenses.feeding= 0;
                                vm.form.if.expenses.public_services= 0;
                                vm.form.if.expenses.education= 0;
                                vm.form.if.expenses.health= 0;
                                vm.form.if.expenses.credits= 0;
                                vm.form.if.expenses.transport= 0;
                                vm.form.if.expenses.others= 0;
                                vm.form.if.expenses.incidentals= 0;
                                vm.form.if.expenses.total= 0;
                                vm.form.b.locked = false;
                                resolve();
                            }).then(function(resolve){
                                if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                    vm.fabActions.push({
                                        name: 'toB',
                                        icon: 'B'
                                    })
                                }
                                vm.toB();
                            });
                        }

                    }
                    else if (scope == 'formIF') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.form.b.locked = false;
                            resolve();
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                vm.fabActions.push({
                                    name: 'toB',
                                    icon: 'B'
                                })
                            }
                            vm.toB();
                        });
                    }
                    else if (scope == 'formB') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.form.of.locked = false;
                            resolve();
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toOF').length > 0) {
                                vm.fabActions.push({
                                    name: 'toOF',
                                    icon: 'OF'
                                })
                            }
                            vm.toOF();
                        });
                    }
                    else if (scope == 'formOF') {
                        var vm = this;
                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                            let promise = new Promise(function(resolve, reject) {
                                vm.form.of.familiar.locked = false;
                                resolve();
                            }).then(function(resolve){
                                if(!vm.fabActions.filter(element=> element.name == 'toOFU').length > 0) {
                                    vm.fabActions.push({
                                        name: 'toOFU',
                                        icon: 'OFU'
                                    })
                                }
                                vm.toOFU();
                            });
                        }
                        else {
                            let promise = new Promise(function(resolve, reject) {
                                vm.form.of.familiar.familiarObligations[0].obligationAmount = 0;
                                vm.form.of.familiar.familiarObligations[0].obligationResidue = 0;
                                vm.form.of.familiar.familiarObligations[0].obligationPaymentValue = 0;
                                vm.form.of.familiar.familiarObligations[1].obligationAmount = 0;
                                vm.form.of.familiar.familiarObligations[1].obligationResidue = 0;
                                vm.form.of.familiar.familiarObligations[1].obligationPaymentValue = 0;
                                vm.form.of.familiar.familiarObligations[2].obligationAmount = 0;
                                vm.form.of.familiar.familiarObligations[2].obligationResidue = 0;
                                vm.form.of.familiar.familiarObligations[2].obligationPaymentValue = 0;
                                vm.form.i.equipment.locked = false;
                                resolve();
                            }).then(function(resolve){
                                if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                    vm.fabActions.push({
                                        name: 'toI',
                                        icon: 'I'
                                    })
                                }
                                vm.toI();
                            });
                        }
                    }
                    else if (scope == 'formOFU') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.form.i.equipment.locked = false;
                            resolve();
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                vm.fabActions.push({
                                    name: 'toI',
                                    icon: 'I'
                                })
                            }
                            vm.toI();
                        });
                    }
                    else if (scope == 'formI') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.form.cp.locked = false;
                            resolve();
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toCP').length > 0) {
                                vm.fabActions.push({
                                    name: 'toCP',
                                    icon: 'CP'
                                })
                            }
                            vm.toCP();
                        });
                    }
                    else if (scope == 'formCP') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.form.i.locked = false;
                            resolve();
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toIFI').length > 0) {
                                vm.fabActions.push({
                                    name: 'toIFI',
                                    icon: 'IFI'
                                })
                            }
                            vm.toIFI();
                        });
                    }
                    else if (scope == 'formIFI') {
                        var vm = this;
                        var sum = 0;
                        if (!this.$store.state.syncReturn) {
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                    sum = sum + 1;
                                }
                            }
                            if (sum > 0) {
                                swal({
                                    title: '¿Está seguro?',
                                    text: 'Algunos indicadores necesitan atención, si continúas esos valores quedarán en 0',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, continuar',
                                    cancelButtonText: 'No, cancelar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.modifiedFinancialIndicators = false;
                                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                            var assign_var = 0;
                                            vm.form.i.financialIndicators[i].value = assign_var;
                                        }
                                    }
                                    vm.$store.dispatch('setConsolidatedBalance', vm.$data).then(()=>{
                                        var payload = {
                                            stage: 'Finalización',
                                            description: 'Se visualiza el balance consolidado.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                                                swal({
                                                    title: 'Codeudor encontrado',
                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                    text: 'Hemos encontrado que agregaste un codeudor, puedes eliminar los codeudores o continuar al menú',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, eliminar',
                                                    cancelButtonText: 'No, ir al menú',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('deleteGuarantors').then(()=>{
                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                                                        });
                                                    });

                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                            vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                                vm.$router.push('/asessments/menu');
                                                            });
                                                        });
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha continuado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                            }
                                            else {
                                                swal({
                                                    title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                                    text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('newSpouse').then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                    });

                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        swal({
                                                            title: '¿Deseas agregar un codeudor?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            vm.$store.dispatch('newGuarantor').then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                            });

                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            if (dismiss == 'cancel') {
                                                                swal({
                                                                    title: '¿Deseas agregar información al FM102?',
                                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                                    text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                                    type: 'warning',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'Si, aceptar',
                                                                    cancelButtonText: 'No, continuar',
                                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                                    buttonsStyling: false
                                                                }).then(() => {
                                                                    var payload = {
                                                                        client: 'customer',
                                                                        actualAssesment: vm.$store.state.actualAssesment,
                                                                        actualStudy: 0
                                                                    }
                                                                    var payload2 = {
                                                                        stage: 'Finalización',
                                                                        description: 'Se finaliza la evaluación.',
                                                                        dateTime: moment().format()
                                                                    };
                                                                    vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                                    vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                                });
                                                                            });
                                                                        });
                                                                    });

                                                                }, function (dismiss) {
                                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                                    var payload = {
                                                                        stage: 'Finalización',
                                                                        description: 'Se finaliza la evaluación.',
                                                                        dateTime: moment().format()
                                                                    };
                                                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                                                                        });
                                                                    });
                                                                })
                                                            }
                                                            else {
                                                                swal({
                                                                    title: 'Cancelado',
                                                                    text: 'El analista no ha finalizado',
                                                                    type: 'error',
                                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                                    buttonsStyling: false
                                                                })
                                                            }
                                                        })
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha finalizado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                            }
                                        });
                                    });

                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                })
                            }
                            else {
                                vm.$store.dispatch('setConsolidatedBalance', vm.$data).then(()=>{
                                    var payload = {
                                        stage: 'Finalización',
                                        description: 'Se visualiza el balance consolidado.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                                            swal({
                                                    title: 'Codeudor encontrado',
                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                    text: 'Hemos encontrado que agregaste un codeudor, puedes eliminar los codeudores o continuar al menú',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, eliminar',
                                                    cancelButtonText: 'No, ir al menú',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('deleteGuarantors').then(()=>{
                                                        swal({
                                                            title: '¿Deseas agregar información al FM102?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            var payload = {
                                                                client: 'customer',
                                                                actualAssesment: vm.$store.state.actualAssesment,
                                                                actualStudy: 0
                                                            }
                                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                    vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                });
                                                            });

                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                                                            });
                                                        })
                                                    });

                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                            vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                                vm.$router.push('/asessments/menu');
                                                            });
                                                        });
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha continuado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                        }
                                        else {
                                            swal({
                                                title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                                text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, aceptar',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                vm.$store.dispatch('newSpouse').then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                });

                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                if (dismiss == 'cancel') {
                                                    swal({
                                                        title: '¿Deseas agregar un codeudor?',
                                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                        text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                        type: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Si, aceptar',
                                                        cancelButtonText: 'No, continuar',
                                                        confirmButtonClass: 'btn btn-success btn-fill',
                                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                                        buttonsStyling: false
                                                    }).then(() => {
                                                        vm.$store.dispatch('newGuarantor').then(()=>{
                                                            vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                        });

                                                    }, function (dismiss) {
                                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                        if (dismiss == 'cancel') {
                                                            swal({
                                                                title: '¿Deseas agregar información al FM102?',
                                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                                text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                                type: 'warning',
                                                                showCancelButton: true,
                                                                confirmButtonText: 'Si, aceptar',
                                                                cancelButtonText: 'No, continuar',
                                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                                buttonsStyling: false
                                                            }).then(() => {
                                                                var payload = {
                                                                    client: 'customer',
                                                                    actualAssesment: vm.$store.state.actualAssesment,
                                                                    actualStudy: 0
                                                                }
                                                                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                        vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                    });
                                                                });

                                                            }, function (dismiss) {
                                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                                var payload = {
                                                                stage: 'Finalización',
                                                                    description: 'Se finaliza la evaluación.',
                                                                    dateTime: moment().format()
                                                                };
                                                                vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                    vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                                                                    });
                                                                });
                                                            })
                                                        }
                                                        else {
                                                            swal({
                                                                title: 'Cancelado',
                                                                text: 'El analista no ha finalizado',
                                                                type: 'error',
                                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                                buttonsStyling: false
                                                            })
                                                        }
                                                    })
                                                }
                                                else {
                                                    swal({
                                                        title: 'Cancelado',
                                                        text: 'El analista no ha finalizado',
                                                        type: 'error',
                                                        confirmButtonClass: 'btn btn-info btn-fill',
                                                        buttonsStyling: false
                                                    })
                                                }
                                            })
                                        }
                                    });
                                });
                            }
                        }
                        else if (this.$store.state.syncReturn) {
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                    sum = sum + 1;
                                }
                            }
                            if (sum > 0) {
                                swal({
                                    title: '¿Está seguro?',
                                    text: 'Algunos indicadores necesitan atención, si continúas esos valores quedarán en 0',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, continuar',
                                    cancelButtonText: 'No, cancelar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.modifiedFinancialIndicators = false;
                                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                            var assign_var = 0;
                                            vm.form.i.financialIndicators[i].value = assign_var;
                                        }
                                    }
                                    vm.$store.dispatch('setConsolidatedBalance', vm.$data).then(()=>{
                                        var payload = {
                                            stage: 'Finalización',
                                            description: 'Se visualiza el balance consolidado.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                                            });
                                        });
                                    });

                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                })
                            }
                            else {
                                vm.$store.dispatch('setConsolidatedBalance', vm.$data).then(()=>{
                                    var payload = {
                                        stage: 'Finalización',
                                        description: 'Se visualiza el balance consolidado.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                                        });
                                    });
                                });
                            }
                        }
                    }
                }
                else {
                    this.$el.querySelector('[data-vv-id="'+this.$validator.errors.items[0].scope+'.'+this.$validator.errors.items[0].field+'"]').focus();
                }
            });
        }
    },
    mounted () {
        // Con la siguiente función evitamos que el usuario pueda retroceder en el historial del navegador
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            history.go(1);
        };
        var studies = JSON.parse(JSON.stringify(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies));
        var firstStudy = JSON.parse(JSON.stringify(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0]));
        var generalBalance = firstStudy.balance[0];
        for (let i=1;i<studies.length;i++) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == studies[i].productType)
            if (product.name.toLowerCase() == 'consumo') {
                var secondProduct = this.$store.getters.getProductTypes.find(product => product.id == studies[0].productType)
                if (secondProduct.name.toLowerCase() == 'consumo') {
                    generalBalance.indebtness = parseFloat(generalBalance.indebtness || 0) + (parseFloat(studies[i].balance[0].indebtness) || 0);
                    generalBalance.er.employees = 0;
                    generalBalance.er.account_sales = 0;
                    generalBalance.er.credit_sales = 0;
                    generalBalance.er.sales_costs = 0;
                    generalBalance.er.operative_expenses.salaries.value = 0;
                    generalBalance.er.operative_expenses.rental.value = 0;
                    generalBalance.er.operative_expenses.public_services.value = 0;
                    generalBalance.er.operative_expenses.taxes.value = 0;
                    generalBalance.er.operative_expenses.transport.value = 0;
                    generalBalance.er.operative_expenses.financial_expenses.value = 0;
                    generalBalance.er.operative_expenses.others.value = 0;
                    generalBalance.er.operative_expenses.incidentals.value = 0;
                    generalBalance.if.incomes.titular_salary = parseFloat(generalBalance.if.incomes.titular_salary || 0) + (parseFloat(studies[i].balance[0].if.incomes.titular_salary) || 0);
                    generalBalance.b.assets.cash = parseFloat(generalBalance.b.assets.cash || 0) + (parseFloat(studies[i].balance[0].b.assets.cash) || 0);
                    generalBalance.b.assets.banks = parseFloat(generalBalance.b.assets.banks || 0) + (parseFloat(studies[i].balance[0].b.assets.banks) || 0);
                    generalBalance.b.assets.saving_accounts = parseFloat(generalBalance.b.assets.saving_accounts || 0) + (parseFloat(studies[i].balance[0].b.assets.saving_accounts) || 0);
                    generalBalance.b.assets.accounts_receivable = parseFloat(generalBalance.b.assets.accounts_receivable || 0) + (parseFloat(studies[i].balance[0].b.assets.accounts_receivable) || 0);
                    generalBalance.b.assets.inventory = parseFloat(generalBalance.b.assets.inventory || 0) + (parseFloat(studies[i].balance[0].b.assets.inventory) || 0);
                    generalBalance.b.assets.others_accounts = parseFloat(generalBalance.b.assets.others_accounts || 0) + (parseFloat(studies[i].balance[0].b.assets.others_accounts) || 0);
                    generalBalance.b.assets.estate = parseFloat(generalBalance.b.assets.estate || 0) + (parseFloat(studies[i].balance[0].b.assets.estate) || 0);
                    generalBalance.b.assets.equipment = parseFloat(generalBalance.b.assets.equipment || 0) + (parseFloat(studies[i].balance[0].b.assets.equipment) || 0);
                    generalBalance.b.assets.vehicle = parseFloat(generalBalance.b.assets.vehicle || 0) + (parseFloat(studies[i].balance[0].b.assets.vehicle) || 0);
                    generalBalance.b.assets.others_assets = parseFloat(generalBalance.b.assets.others_assets || 0) + (parseFloat(studies[i].balance[0].b.assets.others_assets) || 0);
                    generalBalance.b.passives.accounts_payable_suppliers = parseFloat(generalBalance.b.passives.accounts_payable_suppliers || 0) + (parseFloat(studies[i].balance[0].b.passives.accounts_payable_suppliers) || 0);
                    generalBalance.b.passives.banks_credits = parseFloat(generalBalance.b.passives.banks_credits || 0) + (parseFloat(studies[i].balance[0].b.passives.banks_credits) || 0);
                    generalBalance.b.passives.BMM_credits = parseFloat(generalBalance.b.passives.BMM_credits || 0) + (parseFloat(studies[i].balance[0].b.passives.BMM_credits) || 0);
                    generalBalance.b.passives.others_obligations = parseFloat(generalBalance.b.passives.others_obligations || 0) + (parseFloat(studies[i].balance[0].b.passives.others_obligations) || 0);
                    generalBalance.b.passives.banks_credits_fixed_assets = parseFloat(generalBalance.b.passives.banks_credits_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.banks_credits_fixed_assets) || 0);
                    generalBalance.b.passives.BMM_credits_fixed_assets = parseFloat(generalBalance.b.passives.BMM_credits_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.BMM_credits_fixed_assets) || 0);
                    generalBalance.b.passives.others_fixed_assets = parseFloat(generalBalance.b.passives.others_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.others_fixed_assets) || 0);
                    generalBalance.b.passives.patrimony = parseFloat(generalBalance.b.passives.patrimony || 0) + (parseFloat(studies[i].balance[0].b.passives.patrimony) || 0);
                    const array1 =generalBalance.of.business.obligations.concat(studies[i].balance[0].of.business.obligations);
                    generalBalance.of.business.obligations = array1;
                    const array2 =generalBalance.i.equipment.equipment.concat(studies[i].balance[0].i.equipment.equipment || 0);
                    generalBalance.i.equipment.equipment = array2;
                }
                else if (secondProduct.name.toLowerCase() == 'microcrédito' || secondProduct.name.toLowerCase() == 'microcredito') {
                    generalBalance.indebtness = parseFloat(generalBalance.indebtness || 0);
                    generalBalance.er.employees = parseFloat(generalBalance.er.employees || 0);
                    generalBalance.er.account_sales = parseFloat(generalBalance.er.account_sales || 0);
                    generalBalance.er.credit_sales = parseFloat(generalBalance.er.credit_sales || 0);
                    generalBalance.er.sales_costs = parseFloat(generalBalance.er.sales_costs || 0);
                    generalBalance.er.operative_expenses.salaries.value = parseFloat(generalBalance.er.operative_expenses.salaries.value  || 0);
                    generalBalance.er.operative_expenses.rental.value = parseFloat(generalBalance.er.operative_expenses.rental.value  || 0);
                    generalBalance.er.operative_expenses.public_services.value = parseFloat(generalBalance.er.operative_expenses.public_services.value  || 0);
                    generalBalance.er.operative_expenses.taxes.value = parseFloat(generalBalance.er.operative_expenses.taxes.value  || 0);
                    generalBalance.er.operative_expenses.transport.value = parseFloat(generalBalance.er.operative_expenses.transport.value  || 0);
                    generalBalance.er.operative_expenses.financial_expenses.value = parseFloat(generalBalance.er.operative_expenses.financial_expenses.value  || 0);
                    generalBalance.er.operative_expenses.others.value = parseFloat(generalBalance.er.operative_expenses.others.value  || 0);
                    generalBalance.er.operative_expenses.incidentals.value = parseFloat(generalBalance.er.operative_expenses.incidentals.value  || 0);
                    generalBalance.b.assets.cash = parseFloat(generalBalance.b.assets.cash  || 0);
                    generalBalance.b.assets.banks = parseFloat(generalBalance.b.assets.banks  || 0);
                    generalBalance.b.assets.saving_accounts = parseFloat(generalBalance.b.assets.saving_accounts  || 0);
                    generalBalance.b.assets.accounts_receivable = parseFloat(generalBalance.b.assets.accounts_receivable  || 0) + (parseFloat(studies[i].balance[0].b.assets.accounts_receivable) || 0);
                    generalBalance.b.assets.inventory = parseFloat(generalBalance.b.assets.inventory || 0);
                    generalBalance.b.assets.others_accounts = parseFloat(generalBalance.b.assets.others_accounts || 0);
                    generalBalance.b.assets.estate = parseFloat(generalBalance.b.assets.estate || 0);
                    generalBalance.b.assets.equipment = parseFloat(generalBalance.b.assets.equipment || 0);
                    generalBalance.b.assets.vehicle = parseFloat(generalBalance.b.assets.vehicle || 0);
                    generalBalance.b.assets.others_assets = parseFloat(generalBalance.b.assets.others_assets || 0);
                    generalBalance.b.passives.accounts_payable_suppliers = parseFloat(generalBalance.b.passives.accounts_payable_suppliers || 0);
                    generalBalance.b.passives.banks_credits = parseFloat(generalBalance.b.passives.banks_credits || 0);
                    generalBalance.b.passives.BMM_credits = parseFloat(generalBalance.b.passives.BMM_credits || 0);
                    generalBalance.b.passives.others_obligations = parseFloat(generalBalance.b.passives.others_obligations || 0);
                    generalBalance.b.passives.banks_credits_fixed_assets = parseFloat(generalBalance.b.passives.banks_credits_fixed_assets || 0);
                    generalBalance.b.passives.BMM_credits_fixed_assets = parseFloat(generalBalance.b.passives.BMM_credits_fixed_assets || 0);
                    generalBalance.b.passives.others_fixed_assets = parseFloat(generalBalance.b.passives.others_fixed_assets || 0);
                    generalBalance.b.passives.patrimony = parseFloat(generalBalance.b.passives.patrimony || 0);
                    generalBalance.if.incomes.titular_salary = parseFloat(generalBalance.if.incomes.titular_salary || 0) + (parseFloat(studies[i].balance[0].if.incomes.titular_salary) || 0);
                    // const array1 =generalBalance.of.business.obligations.concat(studies[i].balance[0].of.business.obligations);
                    // generalBalance.of.business.obligations = array1;
                    // const array2 =generalBalance.i.equipment.equipment.concat(studies[i].balance[0].i.equipment.equipment);
                    // generalBalance.i.equipment.equipment = array2;
                }
            }
            else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {

                var secondProduct = this.$store.getters.getProductTypes.find(product => product.id == studies[0].productType)
                if (secondProduct.name.toLowerCase() == 'consumo') {
                    generalBalance.indebtness = parseFloat(generalBalance.indebtness || 0) + (parseFloat(studies[i].balance[0].indebtness) || 0);
                    generalBalance.er.employees = 0;
                    generalBalance.er.account_sales = 0;
                    generalBalance.er.credit_sales = 0;
                    generalBalance.er.sales_costs = 0;
                    generalBalance.er.operative_expenses.salaries.value = 0;
                    generalBalance.er.operative_expenses.rental.value = 0;
                    generalBalance.er.operative_expenses.public_services.value = 0;
                    generalBalance.er.operative_expenses.taxes.value = 0;
                    generalBalance.er.operative_expenses.transport.value = 0;
                    generalBalance.er.operative_expenses.financial_expenses.value = 0;
                    generalBalance.er.operative_expenses.others.value = 0;
                    generalBalance.er.operative_expenses.incidentals.value = 0;
                    generalBalance.b.assets.cash = parseFloat(generalBalance.b.assets.cash || 0) + (parseFloat(studies[i].balance[0].b.assets.cash) || 0);
                    generalBalance.b.assets.banks = parseFloat(generalBalance.b.assets.banks || 0) + (parseFloat(studies[i].balance[0].b.assets.banks) || 0);
                    generalBalance.b.assets.saving_accounts = parseFloat(generalBalance.b.assets.saving_accounts || 0) + (parseFloat(studies[i].balance[0].b.assets.saving_accounts) || 0);
                    // generalBalance.b.assets.accounts_receivable = parseFloat(generalBalance.b.assets.accounts_receivable || 0) + (parseFloat(studies[i].balance[0].b.assets.accounts_receivable) || 0);
                    generalBalance.b.assets.accounts_receivable = parseFloat(generalBalance.b.assets.accounts_receivable || 0) + 0;
                    generalBalance.b.assets.inventory = parseFloat(generalBalance.b.assets.inventory || 0) + (parseFloat(studies[i].balance[0].b.assets.inventory) || 0);
                    generalBalance.b.assets.others_accounts = parseFloat(generalBalance.b.assets.others_accounts || 0) + (parseFloat(studies[i].balance[0].b.assets.others_accounts) || 0);
                    generalBalance.b.assets.estate = parseFloat(generalBalance.b.assets.estate || 0) + (parseFloat(studies[i].balance[0].b.assets.estate) || 0);
                    generalBalance.b.assets.equipment = parseFloat(generalBalance.b.assets.equipment || 0) + (parseFloat(studies[i].balance[0].b.assets.equipment) || 0);
                    generalBalance.b.assets.vehicle = parseFloat(generalBalance.b.assets.vehicle || 0) + (parseFloat(studies[i].balance[0].b.assets.vehicle) || 0);
                    generalBalance.b.assets.others_assets = parseFloat(generalBalance.b.assets.others_assets || 0) + (parseFloat(studies[i].balance[0].b.assets.others_assets) || 0);
                    generalBalance.b.passives.accounts_payable_suppliers = parseFloat(generalBalance.b.passives.accounts_payable_suppliers || 0) + (parseFloat(studies[i].balance[0].b.passives.accounts_payable_suppliers) || 0);
                    generalBalance.b.passives.banks_credits = parseFloat(generalBalance.b.passives.banks_credits || 0) + (parseFloat(studies[i].balance[0].b.passives.banks_credits) || 0);
                    generalBalance.b.passives.BMM_credits = parseFloat(generalBalance.b.passives.BMM_credits || 0) + (parseFloat(studies[i].balance[0].b.passives.BMM_credits) || 0);
                    generalBalance.b.passives.others_obligations = parseFloat(generalBalance.b.passives.others_obligations || 0) + (parseFloat(studies[i].balance[0].b.passives.others_obligations) || 0);
                    generalBalance.b.passives.banks_credits_fixed_assets = parseFloat(generalBalance.b.passives.banks_credits_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.banks_credits_fixed_assets) || 0);
                    generalBalance.b.passives.BMM_credits_fixed_assets = parseFloat(generalBalance.b.passives.BMM_credits_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.BMM_credits_fixed_assets) || 0);
                    generalBalance.b.passives.others_fixed_assets = parseFloat(generalBalance.b.passives.others_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.others_fixed_assets) || 0);
                    generalBalance.b.passives.patrimony = parseFloat(generalBalance.b.passives.patrimony || 0) + (parseFloat(studies[i].balance[0].b.passives.patrimony) || 0);
                    const array1 =generalBalance.of.business.obligations.concat(studies[i].balance[0].of.business.obligations || 0);
                    generalBalance.of.business.obligations = array1;
                    const array2 =generalBalance.i.equipment.equipment.concat(studies[i].balance[0].i.equipment.equipment || 0);
                    generalBalance.i.equipment.equipment = array2;
                    if (parseFloat(studies[i].balance[0].if.surplus) > parseFloat((generalBalance.if.incomes.titular_salary*0.4)/0.6)) {
                        generalBalance.if.incomes.others = ((generalBalance.if.incomes.titular_salary*0.4)/0.6);
                    }
                    else {
                        generalBalance.if.incomes.others = parseFloat(studies[i].balance[0].if.surplus) || 0;
                    }
                    this.$data.form =generalBalance;
                    var vm = this;
                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                            var assign_var = 0;
                            vm.form.i.financialIndicators[i].value = assign_var;
                        }
                    }
                    // for (let i=0;i<vm.form.cp.paymentCapacity.length;i++) {
                    //     vm.form.cp.paymentCapacity[i].value = 0;
                    // }
                    // vm.$store.dispatch('setConsolidatedBalance', vm.$data).then(()=>{
                    //     var payload = {
                    //         stage: 'Finalización',
                    //         description: 'Se visualiza el balance consolidado.',
                    //         dateTime: moment().format()
                    //     };
                    //     vm.$store.dispatch('setChangeLog', payload).then(()=>{
                    //         if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                    //             swal({
                    //                     title: 'Codeudor encontrado',
                    //                     // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                    //                     text: 'Hemos encontrado que agregaste un codeudor, puedes eliminar los codeudores o continuar al menú',
                    //                     type: 'warning',
                    //                     showCancelButton: true,
                    //                     confirmButtonText: 'Si, eliminar',
                    //                     cancelButtonText: 'No, ir al menú',
                    //                     confirmButtonClass: 'btn btn-success btn-fill',
                    //                     cancelButtonClass: 'btn btn-danger btn-fill',
                    //                     buttonsStyling: false
                    //                 }).then(() => {
                    //                     vm.$store.dispatch('deleteGuarantors').then(()=>{
                    //                         vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                    //                                 vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                    //                         });
                    //                     });

                    //                 }, function (dismiss) {
                    //                     // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    //                     if (dismiss == 'cancel') {
                    //                         vm.$router.push('/asessments/menu');
                    //                     }
                    //                     else {
                    //                         vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                    //                                 vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                    //                         });
                    //                     }
                    //                 })
                    //         }
                    //         else {
                    //             swal({
                    //                 title: '¿Deseas agregar un estudio del cónyuge del titular?',
                    //                 text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                    //                 type: 'warning',
                    //                 showCancelButton: true,
                    //                 confirmButtonText: 'Si, aceptar',
                    //                 cancelButtonText: 'No, continuar',
                    //                 confirmButtonClass: 'btn btn-success btn-fill',
                    //                 cancelButtonClass: 'btn btn-danger btn-fill',
                    //                 buttonsStyling: false
                    //             }).then(() => {
                    //                 vm.$store.dispatch('newSpouse').then(()=>{
                    //                     vm.$router.push('/asessments/new_asessment/customer/personal_data');
                    //                 });

                    //             }, function (dismiss) {
                    //                 // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    //                 if (dismiss == 'cancel') {
                    //                     swal({
                    //                         title: '¿Deseas agregar un codeudor?',
                    //                         // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                    //                         text: 'Si aceptas, agregarás un codeudor a la evaluación',
                    //                         type: 'warning',
                    //                         showCancelButton: true,
                    //                         confirmButtonText: 'Si, aceptar',
                    //                         cancelButtonText: 'No, continuar',
                    //                         confirmButtonClass: 'btn btn-success btn-fill',
                    //                         cancelButtonClass: 'btn btn-danger btn-fill',
                    //                         buttonsStyling: false
                    //                     }).then(() => {
                    //                         vm.$store.dispatch('newGuarantor').then(()=>{
                    //                             vm.$router.push('/asessments/new_asessment/customer/personal_data');
                    //                         });

                    //                     }, function (dismiss) {
                    //                         // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    //                         if (dismiss == 'cancel') {
                    //                             var payload = {
                    //                                 stage: 'Finalización',
                    //                                 description: 'Se finaliza la evaluación.',
                    //                                 dateTime: moment().format()
                    //                             };
                    //                             vm.$store.dispatch('setChangeLog', payload).then(()=>{
                    //                                 vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                    //                                         vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                    //                                 });
                    //                             });
                    //                         }
                    //                         else {
                    //                             vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                    //                                     vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                    //                             });
                    //                         }
                    //                     })
                    //                 }
                    //                 else {
                    //                     vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                    //                             vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                    //                     });
                    //                 }
                    //             })
                    //         }
                    //     });
                    // });


                }
                else if (secondProduct.name.toLowerCase() == 'microcrédito' || secondProduct.name.toLowerCase() == 'microcredito') {
                    generalBalance.indebtness = parseFloat(generalBalance.indebtness || 0) + (parseFloat(studies[i].balance[0].indebtness) || 0);
                    generalBalance.er.employees = parseFloat(generalBalance.er.employees || 0) + (parseFloat(studies[i].balance[0].er.employees) || 0);
                    generalBalance.er.account_sales = parseFloat(generalBalance.er.account_sales || 0) + (parseFloat(studies[i].balance[0].er.account_sales) || 0);
                    generalBalance.er.credit_sales = parseFloat(generalBalance.er.credit_sales || 0) + (parseFloat(studies[i].balance[0].er.credit_sales) || 0);
                    generalBalance.er.sales_costs = parseFloat(generalBalance.er.sales_costs || 0) + (parseFloat(studies[i].balance[0].er.sales_costs) || 0);
                    generalBalance.er.operative_expenses.salaries.value = parseFloat(generalBalance.er.operative_expenses.salaries.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.salaries.value) || 0);
                    generalBalance.er.operative_expenses.rental.value = parseFloat(generalBalance.er.operative_expenses.rental.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.rental.value) || 0);
                    generalBalance.er.operative_expenses.public_services.value = parseFloat(generalBalance.er.operative_expenses.public_services.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.public_services.value) || 0);
                    generalBalance.er.operative_expenses.taxes.value = parseFloat(generalBalance.er.operative_expenses.taxes.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.taxes.value) || 0);
                    generalBalance.er.operative_expenses.transport.value = parseFloat(generalBalance.er.operative_expenses.transport.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.transport.value) || 0);
                    generalBalance.er.operative_expenses.financial_expenses.value = parseFloat(generalBalance.er.operative_expenses.financial_expenses.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.financial_expenses.value) || 0);
                    generalBalance.er.operative_expenses.others.value = parseFloat(generalBalance.er.operative_expenses.others.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.others.value) || 0);
                    generalBalance.er.operative_expenses.incidentals.value = parseFloat(generalBalance.er.operative_expenses.incidentals.value || 0) + (parseFloat(studies[i].balance[0].er.operative_expenses.incidentals.value) || 0);
                    generalBalance.b.assets.cash = parseFloat(generalBalance.b.assets.cash || 0) + (parseFloat(studies[i].balance[0].b.assets.cash) || 0);
                    generalBalance.b.assets.banks = parseFloat(generalBalance.b.assets.banks || 0) + (parseFloat(studies[i].balance[0].b.assets.banks) || 0);
                    generalBalance.b.assets.saving_accounts = parseFloat(generalBalance.b.assets.saving_accounts || 0) + (parseFloat(studies[i].balance[0].b.assets.saving_accounts) || 0);
                    generalBalance.b.assets.accounts_receivable = parseFloat(generalBalance.b.assets.accounts_receivable || 0) + (parseFloat(studies[i].balance[0].b.assets.accounts_receivable) || 0);
                    generalBalance.b.assets.inventory = parseFloat(generalBalance.b.assets.inventory || 0) + (parseFloat(studies[i].balance[0].b.assets.inventory) || 0);
                    generalBalance.b.assets.others_accounts = parseFloat(generalBalance.b.assets.others_accounts || 0) + (parseFloat(studies[i].balance[0].b.assets.others_accounts) || 0);
                    generalBalance.b.assets.estate = parseFloat(generalBalance.b.assets.estate || 0) + (parseFloat(studies[i].balance[0].b.assets.estate) || 0);
                    generalBalance.b.assets.equipment = parseFloat(generalBalance.b.assets.equipment || 0) + (parseFloat(studies[i].balance[0].b.assets.equipment) || 0);
                    generalBalance.b.assets.vehicle = parseFloat(generalBalance.b.assets.vehicle || 0) + (parseFloat(studies[i].balance[0].b.assets.vehicle) || 0);
                    generalBalance.b.assets.others_assets = parseFloat(generalBalance.b.assets.others_assets || 0) + (parseFloat(studies[i].balance[0].b.assets.others_assets) || 0);
                    generalBalance.b.passives.accounts_payable_suppliers = parseFloat(generalBalance.b.passives.accounts_payable_suppliers || 0) + (parseFloat(studies[i].balance[0].b.passives.accounts_payable_suppliers) || 0);
                    generalBalance.b.passives.banks_credits = parseFloat(generalBalance.b.passives.banks_credits || 0) + (parseFloat(studies[i].balance[0].b.passives.banks_credits) || 0);
                    generalBalance.b.passives.BMM_credits = parseFloat(generalBalance.b.passives.BMM_credits || 0) + (parseFloat(studies[i].balance[0].b.passives.BMM_credits) || 0);
                    generalBalance.b.passives.others_obligations = parseFloat(generalBalance.b.passives.others_obligations || 0) + (parseFloat(studies[i].balance[0].b.passives.others_obligations) || 0);
                    generalBalance.b.passives.banks_credits_fixed_assets = parseFloat(generalBalance.b.passives.banks_credits_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.banks_credits_fixed_assets) || 0);
                    generalBalance.b.passives.BMM_credits_fixed_assets = parseFloat(generalBalance.b.passives.BMM_credits_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.BMM_credits_fixed_assets) || 0);
                    generalBalance.b.passives.others_fixed_assets = parseFloat(generalBalance.b.passives.others_fixed_assets || 0) + (parseFloat(studies[i].balance[0].b.passives.others_fixed_assets) || 0);
                    generalBalance.b.passives.patrimony = parseFloat(generalBalance.b.passives.patrimony || 0) + (parseFloat(studies[i].balance[0].b.passives.patrimony) || 0);
                    const array1 =generalBalance.of.business.obligations.concat(studies[i].balance[0].of.business.obligations || 0);
                    generalBalance.of.business.obligations = array1;
                    const array2 =generalBalance.i.equipment.equipment.concat(studies[i].balance[0].i.equipment.equipment || 0);
                    generalBalance.i.equipment.equipment = array2;
                }
            }



        }
        this.$data.form =generalBalance;
        this.fabActions = this.fabActions2;
        if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse) && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length > 0 && this.$store.state.assesments[this.$store.state.syncAssessment].customerSpouse.customerFirstName != null) {
            // var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].productType);
            // if (product.name.toLowerCase() == 'consumo') {
            //     this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].if.incomes.total;
            // }
            // else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
            //     this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit;
            // }
        }
        // console.info(generalBalance);
    }
}
</script>
<style>
.fab-main .material-icons{
    color: black !important;
    background-color: #F09500 !important;
}
.fab-list li .material-icons{
    color: black !important;
    font-family: "Helvetica Neue" !important;
    font-size: 12px !important;
}
.center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
.orange {
    color: #F09500;
}
.white {
    color: white;
}
</style>
